import FailurePage from './FailurePage';

export default FailurePage;
